export const NUM_FMT_PREFS_KEY = "numFmt";
export const DEFAULT_NUM_FMT = "ru";
export function isNumFmt(v) {
    return v === "ru" || v === "en" || v === "plain";
}
// resolveNumFmt — незнакомое/отсутствующее значение (мусор, старая версия клиента) → ru.
export function resolveNumFmt(raw) {
    return isNumFmt(raw) ? raw : DEFAULT_NUM_FMT;
}
